import Callout from '../components/Callout';
import './Home.scss';
import Cards from '../components/CardsGrid';
import Contact from '../partials/Contact';

const Home = () => {

    return (
        <div className='homepage'>
            <section className="page container">
                <Callout
                    title="Ethical, affordable, and professional digital services."
                    eyebrow="Baked with Care"
                    description=""
                >
                    <p>
                    <span className="bold">Put your mission first. </span>
                    Accessible and high-quality technical solutions are for everyone—not just big tech companies.
                    </p>
                    <p>
                    We were started by mission-driven software developers, designers, product leaders, and non-profit founders. Digital services from web design, web development, and social media marketing can get extremely pricey, especially in today's economy.
                    </p>
                </Callout>
                <Cards 
                    sectionTitle='Collective Values'
                />
                <Contact />
            </section>
        </div>
    )
}

export default Home;